import * as React from 'react';

import { translate } from '~l10n/client';
import { ExternalLink } from '~shared/components/ExternalLink/ExternalLink';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';

type SubHeading = 'insightsFromResults' | 'questionsFromInsights';
type LearnMoreArticleConfig = { base: string } & Record<SubHeading, string>;
type LearnMoreArticleConfigMap = Record<
  TeacherApplicationContext,
  LearnMoreArticleConfig
>;

const learnMoreArticleConfig: LearnMoreArticleConfigMap = {
  [TeacherApplicationContext.ShowbieAssessments]: {
    base: 'https://support.showbie.com/en/articles/12844724-results-insights',
    insightsFromResults: '#h_e74693708d',
    questionsFromInsights: '#h_8d440a7ab5',
  },
  [TeacherApplicationContext.Socrative]: {
    base: 'https://help.socrative.com/en/articles/12844689-results-insights',
    insightsFromResults: '#h_6b32e65b44',
    questionsFromInsights: '#h_cb3d95745d',
  },
};

interface InsightsLearnMoreLinkProps {
  subheading?: SubHeading;
}

export function InsightsLearnMoreLink({
  subheading,
}: InsightsLearnMoreLinkProps) {
  const helpLink = useGetInsightsLearnMoreLink(subheading);

  return (
    <ExternalLink
      onClickCapture={(event) => {
        event.stopPropagation();
      }}
      href={helpLink}
    >
      {translate('Learn More')}
    </ExternalLink>
  );
}

interface GetInsightsLearnMoreLinkParams {
  applicationContext: TeacherApplicationContext;
  subheading: 'insightsFromResults' | 'questionsFromInsights';
}

export function getInsightsLearnMoreLink({
  applicationContext,
  subheading,
}: GetInsightsLearnMoreLinkParams) {
  const config = learnMoreArticleConfig[applicationContext];
  return config.base + (config[subheading] ?? '');
}

function useGetInsightsLearnMoreLink(subheading?: SubHeading) {
  const applicationContext = useTeacherApplicationContext();
  return getInsightsLearnMoreLink({
    applicationContext,
    subheading,
  });
}
